import {THEME_ENUM as ButtonThemes} from '../../components/button';

export const THEME = {
  PRIMARY: `primary`,
  SECONDARY: `secondary`,
  BUILDER: `builder`,
  ...ButtonThemes,
};

export const TRACKING_EVENTS = {
  LEXICON_TAG_SELECTED: `[Lexicon] Select Report Events Tag`,
};

export const SELECTOR_TYPE = {
  TEXT: `text`,
  BUTTON: `button`,
};
